type SubscriptionUsageOptions = {
	isFree?: boolean;
};

const getSubscriptionUsage = (subscription: any = {}, options: SubscriptionUsageOptions = {}) => {
	const billingPeriod = subscription.billingPeriod || {};
	const usage = subscription.usage || {};
	const toCredits = value => {
		if (value === null || value === undefined || value === '') return undefined;
		const credits = Number(value);
		return Number.isFinite(credits) && credits >= 0 ? credits : undefined;
	};
	const planCredits = toCredits(subscription.price?.meteredPrice?.threshold);
	const periodCredits = toCredits(billingPeriod.includedCredits);
	const ledgerCredits = toCredits(usage.totalCredits);
	const allocations = [planCredits, periodCredits, ledgerCredits].filter(value => value !== undefined);
	const totalCredits = allocations.length ? Math.max(...allocations) : undefined;
	const usedCredits = toCredits(usage.usedCredits) ?? toCredits(billingPeriod.includedCreditsUsed);
	const hasUsage = totalCredits !== undefined && usedCredits !== undefined;
	const overageCredits = hasUsage ? Math.max(usedCredits - totalCredits, 0) : undefined;
	const remainingCredits = hasUsage ? Math.max(totalCredits - usedCredits, 0) : undefined;
	const percentUsed = hasUsage && totalCredits > 0 ? (usedCredits / totalCredits) * 100 : 0;
	const productIsFree = subscription.product?.uuid === 'free' || subscription.product?.key === 'free';
	const isFree = Boolean(options.isFree || subscription.isFree || productIsFree);
	const atLimit = Boolean(hasUsage && totalCredits > 0 && usedCredits >= totalCredits);

	return {
		planCredits,
		periodCredits,
		ledgerCredits,
		totalCredits,
		usedCredits,
		remainingCredits,
		overageCredits,
		percentUsed,
		hasUsage,
		isFree,
		isOverage: atLimit && !isFree,
		isDepleted: atLimit && isFree,
		endDate: usage.endDate ?? billingPeriod.periodEnd ?? subscription.currentPeriodEnd,
	};
};

export { getSubscriptionUsage };
export type { SubscriptionUsageOptions };
